import { render } from "./TextInput.vue?vue&type=template&id=0053f992&scoped=true&ts=true"
import script from "./TextInput.vue?vue&type=script&lang=ts"
export * from "./TextInput.vue?vue&type=script&lang=ts"

import "./TextInput.vue?vue&type=style&index=0&id=0053f992&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0053f992"]])

export default __exports__